export default __webpack_public_path__ + "static/media/delete.946578f3.svg";